<template>
  <span>
    <i class="fa-light fa-share pulsante_comando" @click="openModal()" style="padding: 8px" v-if="showButton" />
    <div
      aria-labelledby="modalShare"
      :id="`share_modal_${this.resource}_${this.id}`"
      class="modal share-popup"
      role="dialog"
      v-show="isModalVisible"
    >
      <header class="modal-header">
        <i class="fa-light fa-share fa-2x" />
        <h3 class="title">{{ i18nJS.condividi_con }}</h3>
        <button type="button" class="btn-close" @click="close" aria-label="Close modal">
          <i class="fa-light fa-xmark"></i>
        </button>
      </header>
      <div class="modal-body">
        <div class="job-select">
          <i class="fa-light fa-user-tag js-tooltip" :title="i18nJS.job" />
          <v-select2
            v-model="new_jobs"
            :element_id.sync="new_jobs"
            :element_description.sync="description_jobs"
            :id="`share-jobs-select-${id}`"
            :options-list="job_options"
            :multiple="true"
          />
        </div>
        <div class="user-select">
          <i class="fa-light fa-user js-tooltip" :title="i18nJS.user" />
          <v-select2 v-model="new_user_ids" :id="`share-users-select-${id}`" :multiple="true" :selectConfig="selectConfig" />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="saveShare" aria-label="Save modal">
          {{ i18nJS.command.save }}
        </button>
      </div>
    </div>
  </span>
</template>

<script>
import axios from 'axios';
import vSelect2 from '../vSelect2';

export default {
  name: 'share',
  computed: {
    saveShareUrl() {
      return `/${window.locale}/business_units/${this.$attrs.business_unit_id}/share/${this.resource}/${this.id}.json`;
    },
    ubuPath() {
      return `/${window.locale}/users_business_units/autocomplete_user_firstname.json?business_unit_id=${this.business_unit_id}`;
    },
    selectConfig() {
      return {
        placeholder: `${window.i18nJS.activity.selectEl}`,
        url: `${this.ubuPath}?sel`,
        processResults: this.processResults,
      };
    },
    i18nJS() {
      return window.i18nJS;
    },
  },
  data() {
    return {
      firstModalOpen: true,
      isModalVisible: false,
      new_user_ids: [],
      new_jobs: [],
      description_jobs: [],
    };
  },
  props: ['id', 'resource', 'share', 'job_options', 'share_options', 'showButton'],
  components: {
    vSelect2,
  },
  mounted() {
    eventBus.$on('initUserSelect', this.handleSelectUserInit);
    eventBus.$on('editShare', this.handleEditShare);
    if (this.shared_jobs) {
      this.$set(this, 'vjobs', this.shared_jobs);
      this.$set(this.$refs.share, 'new_jobs', this.shared_jobs);
      $(`#share-users-select-${this.id}`).trigger('change');
    }
  },
  methods: {
    close() {
      this.isModalVisible = false;
    },
    handleSelectUserInit(event) {
      if (this.id == event.id && this.resource == event.resource) {
        var $select = $(`#share-users-select-${this.id}`);
        for (const key in event.selected) {
          const fn = event.selected[key];
          var $option = $(`<option selected>${fn}</option>`).val(key);
          $select.append($option);
        }
        $select.trigger('change');
      }
    },
    handleEditShare(event) {
      if (this.id == event.id && this.resource == event.resource) {
        this.openModal();
      }
    },
    openModal() {
      this.isModalVisible = true;
      if (this.firstModalOpen) {
        $(`#share-jobs-select-${this.id}`).trigger('change');
        $(`#share-users-select-${this.id}`).trigger('change');
        this.firstModalOpen = false;
      }
    },
    processResults(data) {
      if (data) {
        return {
          results: data.map((res) => {
            return { text: res.label, id: res.id };
          }),
          pagination: {
            more: data.length === 30,
          },
        };
      } else {
        return {};
      }
    },
    saveShare() {
      eventBus.$emit('shareUpdates', { id: this.id, resource: this.resource, jobs: this.new_jobs, user_ids: this.new_user_ids });
      this.close();
    },
  },
};
</script>

<style lang="scss">
[aria-labelledby='modalShare'] .select2-search__field {
  width: inherit !important;
}
</style>
<style lang="scss" scoped>
.modal-body {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin: 0 0 1em;

  & > .select2-container {
    width: 300px;
  }
}
.btn-close {
  background: inherit;
  border: 0;
}
.modal-header {
  display: flex;
  height: 2.5em;
  justify-content: space-between;
}
.job-select,
.user-select {
  display: block;
  & > i {
    margin: 1em;
  }
  & > select {
    width: 450px;
    margin: 1em;
  }
}
</style>
